import { CJM } from '@pages/IntroducingBroker/Dashboard/CJM/CJM'
import { useCJM } from '@pages/IntroducingBroker/Dashboard/hooks/useCJM'

export const CJMWidget = () => {
  const {
    data: ibCJMData,
    isLoading: ibCJMDataLoading,
    dateRange: ibCJMDateRange,
    setDateRange: setIBCJMDateRange,
  } = useCJM()

  return (
    <CJM
      isLoading={ibCJMDataLoading}
      ibCJMData={ibCJMData}
      dateRange={ibCJMDateRange}
      setDateRange={setIBCJMDateRange}
    />
  )
}
